import React, { FC, ReactElement } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router';
import i18next from 'i18next';

const CONTACT_EMAIL: string = 'info@enlivio.com';
const HELP_URL: string = 'https://www.enlivio.com/hilfe/';
const ABOUT_URL: string = '/about';
const IMPRINT_URL: string = 'https://www.enlivio.com/impressum/';
const TERMS_URL: string = 'https://www.enlivio.com/wp-content/uploads/2021/11/AGB_Enlivio_B2B_v3_inclAVV_Physio.pdf';
const PRIVACY_URL: string = 'https://www.enlivio.com/wp-content/uploads/2021/11/20211027-heyData_Datenschutzerkla%CC%88rung-Website_DE_room4-Softwareentwicklung-GmbH_https___app.enlivio.com-1.pdf';
const FEEDBACK_URL: string = 'https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/23';

type FooterLink = {
  href: string;
  label: string;
  external: boolean;
};

function isRouteLink(href: string): boolean {
  return href.startsWith('/');
}

const Footer: FC = (): ReactElement => {
  const year: number = new Date().getFullYear();

  const links: FooterLink[] = [
    { href: `mailto:${CONTACT_EMAIL}`, label: CONTACT_EMAIL, external: false },
    { href: HELP_URL, label: i18next.t('footer.help'), external: true },
    { href: ABOUT_URL, label: i18next.t('footer.about'), external: false },
    { href: IMPRINT_URL, label: i18next.t('footer.imprint'), external: true },
    { href: TERMS_URL, label: i18next.t('footer.terms'), external: true },
    { href: PRIVACY_URL, label: i18next.t('footer.privacy'), external: true },
    { href: FEEDBACK_URL, label: i18next.t('footer.feedback'), external: true },
  ];

  return (
    <footer className="bg-dark mt-auto py-3">
      <Container className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center gap-2">
        <div className="text-white mx-1">
          &copy; Enlivio {year}
          {links.map((link: FooterLink) => (
            <React.Fragment key={link.href}>
              {' | '}
              {isRouteLink(link.href) ? (
                <Link to={link.href} className="text-white text-decoration-underline mx-1">
                  {link.label}
                </Link>
              ) : (
                <a
                  href={link.href}
                  className="text-white text-decoration-underline mx-1"
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener noreferrer' : undefined}
                >
                  {link.label}
                </a>
              )}
            </React.Fragment>
          ))}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
